<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div class="jm margem modal-visualizar-despesa" @click.stop>
            <div class="modal-header">
                <h3>Detalhes da Despesa</h3>
            </div>

            <div class="grid-2">
                <div v-if="mostrarProjeto" class="col-2">
                    <label>Projeto</label>
                    <p class="campo-valor">{{ labelProjeto }}</p>
                </div>
                <div>
                    <label>Data</label>
                    <p class="campo-valor">{{ formatarData(despesa?.data) }}</p>
                </div>
                <div>
                    <label>Valor</label>
                    <p class="campo-valor">
                        <span v-if="podeVerValor">{{ formatarValor(despesa?.valor) }}</span>
                        <span v-else>●●●●●</span>
                    </p>
                </div>
                <div>
                    <label>Fornecedor</label>
                    <p class="campo-valor">{{ despesa?.fornecedor || '-' }}</p>
                </div>
                <div>
                    <label>Motivo</label>
                    <p class="campo-valor">{{ despesa?.motivacao?.nome || '-' }}</p>
                </div>
                <div>
                    <label>Categoria de Despesa</label>
                    <p class="campo-valor">{{ labelCategoria }}</p>
                </div>
                <div>
                    <label>Responsável</label>
                    <p class="campo-valor">{{ despesa?.responsavel?.name || '-' }}</p>
                </div>
                <div>
                    <label>Cadastrado por</label>
                    <p class="campo-valor">{{ despesa?.criado_por?.name || '-' }}</p>
                </div>
                <div class="col-2">
                    <label>Descrição</label>
                    <p class="campo-valor campo-valor--texto">{{ despesa?.descricao || '-' }}</p>
                </div>
                <div class="col-2">
                    <label>Observação</label>
                    <p class="campo-valor campo-valor--texto">{{ despesa?.observacao || '-' }}</p>
                </div>
            </div>

            <div class="modal-footer">
                <div class="submit">
                    <button class="acao-secundaria" @click="$emit('fechar')">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalVisualizarDespesaProjeto',

    props: {
        mostrar: { type: Boolean, default: false },
        despesa: { type: Object, default: null },
        mostrarProjeto: { type: Boolean, default: true },
        podeVerValor: { type: Boolean, default: true },
    },

    emits: ['fechar'],

    computed: {
        labelProjeto() {
            const projeto = this.despesa?.projeto
            if (!projeto) return '-'
            const codigo = projeto.codigo || projeto.pcm_codigo
            const nome = projeto.nome || ''
            if (codigo && nome) return `${codigo} - ${nome}`
            return codigo || nome || '-'
        },
        labelCategoria() {
            const cat = this.despesa?.categoria_orcamento
            if (!cat) return '-'
            const codigo = cat.codigo || ''
            const descricao = cat.descricao || ''
            if (codigo && descricao) return `${codigo} - ${descricao}`
            return codigo || descricao || '-'
        },
    },

    methods: {
        formatarValor(valor) {
            if (valor == null || Number.isNaN(Number(valor))) return '-'
            return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        formatarData(data) {
            if (!data) return '-'
            const [ano, mes, dia] = String(data).slice(0, 10).split('-')
            if (!ano || !mes || !dia) return data
            return `${dia}/${mes}/${ano}`
        },
    },
}
</script>

<style scoped>
.modal-visualizar-despesa {
    position: relative !important;
    display: flex;
    flex-direction: column;
    min-width: min(640px, 92vw);
    max-width: 720px;
    width: min(720px, 94vw);
    max-height: 90vh;
    margin: 1rem auto !important;
    overflow: hidden;
    box-sizing: border-box;
}
.modal-visualizar-despesa .grid-2 {
    flex: 1 1 auto;
    min-height: 0;
    max-height: calc(90vh - 9rem);
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
}
.campo-valor {
    margin: 0.25rem 0 0;
    min-height: 1.4rem;
    word-break: break-word;
}
.campo-valor--texto {
    white-space: pre-wrap;
}
</style>
